// Same shape as rejectedApi.js: one function per product-fields route
// (server dashboard/photoPipeline.js, shapes in photoPipeline/productFields.js).
// The save is quiet: the panel shows a failed save itself, landed/failed lists included.
const BASE = 'photo-pipeline/product-fields'

export const getProductFields = (fetchResource, sku) => fetchResource({ method: 'GET', resource: `${BASE}/${sku}`, loadingKey: 'fields' })
export const putProductFields = (fetchResource, sku, fields) =>
    fetchResource({ method: 'PUT', resource: `${BASE}/${sku}`, body: { fields }, loadingKey: 'fieldsSave', quiet: true })
